<!-- eslint-disable max-len -->
<template>
  <div class="invasive-tab">
    <div class="section-header" v-for="species in schema.fields" :key="species.field">
      <InvasiveDetails
        :schema="schema"
        :model="model.invasiveSpeciesDetails"
        :species="species"
        @validated="onValidate"
      />
    </div>
  </div>
</template>

<script>
import InvasiveDetails from '@/components/common/InvasiveDetails.vue';

export default {
  name: 'Invasives',
  props: ['schema', 'model'],
  components: {
    InvasiveDetails,
  },
  methods: {
    onValidate(value) {
      this.$emit('validated', value);
    },
  },
};
</script>
